<template>
  <div class="view-ebook-home">
    <ebook-header />

    <div class="container-fluid pt-5">
      <ebook-section v-if="hasEbook" />
      <ebook-empty-state v-else-if="!filesLoading" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import EbookHeader from "@/components/home/EbookHeader";
import EbookEmptyState from "@/components/home/EbookEmptyState";
import EbookSection from "@/components/home/EbookSection";

export default {
  name: "EbookHome",
  components: {
    EbookHeader,
    EbookEmptyState,
    EbookSection
  },
  computed: {
    ...mapGetters("ebookReader", ["hasEbook"]),
    ...mapState("ebookReader", ["filesLoading"])
  },
  mounted() {
    this.$store.dispatch("ebookReader/fetchFiles");
  }
};
</script>

<style lang="scss" scoped>
.view-ebook-home {
  min-height: 100vh;
}
</style>
